import fetch from 'node-fetch'
import React, { ReactElement, useEffect, useState } from 'react'
import ComponentMap, { ContentfulComponentId } from '../ComponentMap'

const fetchJson = async (url: string) => {
  const res = await fetch(url)
  const json = await res.json()
  return json
}

interface IJsonModule {
  url: string
}

interface IData {
  id: ContentfulComponentId
  [x: string]: string //allow any other props in this type
}

/**
 * The JsonModule component allows modules to be added to the RichText that do not have a specific contentful integration.
 *
 * To use this module, first you need a JSON file that with the props for the component you wish to render.
 * Additionally, this file needs an entry with the key "id", where the value can be used by the <ComponentMap />
 *
 * @param url A Url that points to a JSON file containing the props for the specified component
 * @returns
 */
const JsonModule = ({ url }: IJsonModule): ReactElement => {
  const [data, setData] = useState<IData | null>()

  useEffect(() => {
    ;(async () => {
      const json = await fetchJson(`https:${url}`)
      setData(json)
    })()
  }, [])

  if (!data) return <></>

  const { id, ...props } = data

  return data ? <ComponentMap internal={{ type: id }} {...props} /> : <p>loading</p>
}

export default JsonModule
